import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
//  conciliationResult: ['result'],
    setProviderList: [],
    setLoadingProviderUpdate: [],
    setSelectedProvider: [],
    unsetSelectedProvider: [],
    setProviderFilter: [],
    cleanProviderList: [],
    setProviderPreScheduling: [],
    unsetProviderPreScheduling: [],
    setFetchedProvidersBySubcontractor: [],
    cleanProvidersBySubcontractor: [],
    setLoadingProvidersBySubcontractor: [],
    setFetchedProvidersNotLinkedSubcon: [],
    cleanProvidersNotLinkedSubcon: [],
    setLoadingProvidersNotLinkedSubcon: [],
    setReloadProviderList: [],
    setLoadingProviderList: [],
    setProviderToast: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    providerList: {
        fornecedoresFiltrados: []
    },
    isLoadingProviderUpdate: false,
    isLoadingProviderList: false,
    selectedProvider: {
        id: null,
        data: {}
    },
    filter: {
        status: '',
        cnpj: ''    
    },
    providerIdPreScheduling: {
        id: null,
        data: {}
    },
    fetchedProvidersBySubcontractor: {
        buscarFornecedorPorSubcontratado: [],
        loading: false,
        reloadProviderList: 0
    },
    fetchedProvidersNotLinkedSubcon: {
        buscarFornecedorNaoVinculadoAoSubcontratado: [],
        loading: false
    },
    showModal: false,
    providerToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
};
 
const setProviderList = (state = INITIAL_STATE, action) => {
    return { ...state, providerList: action.payload };
}

const setLoadingProviderUpdate = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingProviderUpdate: action.payload };
}

const setSelectedProvider = (state = INITIAL_STATE, action) => {
    return { ...state, selectedProvider: action.payload };
}

const unsetSelectedProvider = (state = INITIAL_STATE, action) => {
    return { ...state, selectedProvider: action.payload };
}

function setProviderFilter(state = INITIAL_STATE, action) {
    return { 
      ...state,
      filter: action.filter,
    }
}

const cleanProviderList = (state = INITIAL_STATE, action) => {
    return { ...state, providerList: action.payload };
}

const setProviderPreScheduling = (state = INITIAL_STATE, action) => {
    return { ...state, providerIdPreScheduling: action.payload };
}

const unsetProviderPreScheduling = (state = INITIAL_STATE, action) => {
    return { ...state, providerIdPreScheduling: action.payload };
}

const setFetchedProvidersBySubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersBySubcontractor: { ...state.fetchedProvidersBySubcontractor, buscarFornecedorPorSubcontratado: action.payload.buscarFornecedorPorSubcontratado } }
}

const cleanProvidersBySubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersBySubcontractor: { ...state.fetchedProvidersBySubcontractor, buscarFornecedorPorSubcontratado: [] } };
}

const setLoadingProvidersBySubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersBySubcontractor: { ...state.fetchedProvidersBySubcontractor, loading: action.payload } };
}

const setReloadProviderList = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersBySubcontractor: { ...state.fetchedProvidersBySubcontractor, reloadProviderList: state.fetchedProvidersBySubcontractor.reloadProviderList + 1 } };
}

const setFetchedProvidersNotLinkedSubcon = (state = INITIAL_STATE, action) => {
    var list = action.payload.buscarFornecedorNaoVinculadoAoSubcontratado;
    list.unshift({id: -1, nome: '--- Selecione um fornecedor'});
    return { ...state, fetchedProvidersNotLinkedSubcon: { buscarFornecedorNaoVinculadoAoSubcontratado: list }};
}

const cleanProvidersNotLinkedSubcon = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersNotLinkedSubcon: { ...state.fetchedProvidersNotLinkedSubcon, buscarFornecedorNaoVinculadoAoSubcontratado: [] } };
}

const setLoadingProvidersNotLinkedSubcon = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedProvidersNotLinkedSubcon: { ...state.fetchedProvidersNotLinkedSubcon, loading: action.payload } };
}

const setLoadingProviderList = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingProviderList: action.payload};
}

const setProviderToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        providerToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_PROVIDER_LIST]: setProviderList,
    [Types.SET_LOADING_PROVIDER_UPDATE]: setLoadingProviderUpdate,
    [Types.SET_SELECTED_PROVIDER]: setSelectedProvider,
    [Types.UNSET_SELECTED_PROVIDER]: unsetSelectedProvider,
    [Types.SET_PROVIDER_FILTER]: setProviderFilter,
    [Types.CLEAN_PROVIDER_LIST]: cleanProviderList,
    [Types.SET_PROVIDER_PRE_SCHEDULING]: setProviderPreScheduling,    
    [Types.UNSET_PROVIDER_PRE_SCHEDULING]: unsetProviderPreScheduling,
    [Types.SET_FETCHED_PROVIDERS_BY_SUBCONTRACTOR]: setFetchedProvidersBySubcontractor,
    [Types.CLEAN_PROVIDERS_BY_SUBCONTRACTOR]: cleanProvidersBySubcontractor,
    [Types.SET_LOADING_PROVIDERS_BY_SUBCONTRACTOR]: setLoadingProvidersBySubcontractor,
    [Types.SET_RELOAD_PROVIDER_LIST]: setReloadProviderList,
    [Types.SET_FETCHED_PROVIDERS_NOT_LINKED_SUBCON]: setFetchedProvidersNotLinkedSubcon,
    [Types.CLEAN_PROVIDERS_NOT_LINKED_SUBCON]: cleanProvidersNotLinkedSubcon,
    [Types.SET_LOADING_PROVIDERS_NOT_LINKED_SUBCON]: setLoadingProvidersNotLinkedSubcon,
    [Types.SET_LOADING_PROVIDER_LIST]: setLoadingProviderList,
    [Types.SET_PROVIDER_TOAST]: setProviderToast,
});
 